import colors from 'globals/colors'
import measures from 'globals/measures'
import styled from 'styled-components'

interface InputWrapperProps {
  hasError: boolean,
  nbPerLine: number,
  noBottomPadding?: boolean,
  bottomPadding?: number
}

export const InputWrapper = styled.div<InputWrapperProps>`
  
  & > .ant-input-affix-wrapper {
    padding: 8px 12px;
  }
  
  ${(props) => !props.noBottomPadding && `
    padding-bottom: 17px;
  `};
  
  ${(props) => props.bottomPadding && `
    padding-bottom: ${props.bottomPadding}px;
  `};
  
  ${(props) => props.hasError && `
    & .ant-input {
      border-color: ${colors.reddishPink};
    }
  `};
  
  flex-basis: calc(${(props) => 100 / props.nbPerLine}% - ${(props) => 5 * (props.nbPerLine - 1)}px);
  
  @media (max-width: ${measures.mobileThreshold}px) {
    flex-basis: 100%;
  }
`

export const SuffixIcon = styled.img`
  width: 10px;
  height: 10px;
`

interface ValidateTextProps {
  disabled?: boolean
}

export const ValidateText = styled.span<ValidateTextProps>`
  ${(props) => props.disabled == true && `
    color: ${colors.lightGrey};
  `};

  ${(props) => props.disabled != true && `
    color: ${colors.waterBlue};
  `};

  font-weight: 600;
  cursor: pointer;
`

export const InputLabel = styled.div`
  line-height: 19px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 11px;
`

export const Required = styled.span `
  color: ${colors.waterBlue};
`

